import * as React from 'react';
import { 
    Navibar,
    IntroLandning,
    InfoOurSite,
    Footer
} from '~/components/homepage';

import { connect } from "react-redux";

interface IHomepage { 
    dispatch: Function  
}
function Homepage(props: IHomepage) {
    return (
        <div className='Homepage'>
            <Navibar />
            <IntroLandning />
            <InfoOurSite />
            <Footer />
        </div>
    );
}

const mapStateToProps = (state: object) => {
    return {
        ...state,
    }
}

export default connect(mapStateToProps)(Homepage);



// WEBPACK FOOTER //
// ./src/containers/Homepage.tsx